import { useApi, createApiHook } from "../utils/apiUtils";

const useImportQuestionsFromExcel = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const importFromExcel = async (file) => {
    if (!file) return { ok: false };

    startLoading();

    const formData = new FormData();
    formData.append("file", file);

    const response = await apiPost("/questions/import_from_excel", "Error al subir el archivo Excel", formData, {
      "Content-Type": "multipart/form-data",
    });

    setResponse(response);

    return {
      data: response?.data,
      status: response?.status,
      errorMessage: response?.error,
    };
  };

  return { importFromExcel, data, error, loading };
};

export default useImportQuestionsFromExcel;
